const graphqlError = (error, errorPrefix = "GraphQL error:") => {
  return error.replace(errorPrefix, "")
}

export { graphqlError }
